<div class="info-page">
  <div class="info-card mat-elevation-z4">
    <div class="info-header">
      <span class="info-badge">Informare</span>
      <h1 class="info-title">Rezervările se mută pe <strong>student.upt.ro</strong></h1>
      <p class="info-lead">
        Aplicația rezervari.upt.ro este retrasă din utilizare începând cu
        <strong>3 octombrie 2026</strong>.
      </p>
    </div>

    <div class="info-items">
      <div class="info-item">
        <div class="info-date">12–18 oct</div>
        <div class="info-text">
          Rezervările se fac de pe platforma <strong>student.upt.ro</strong>,
          începând cu această săptămână.
        </div>
      </div>

      <div class="info-item">
        <div class="info-date">Tranziție</div>
        <div class="info-text">
          Administratorii și comitetele de cămin au fost rugați să asigure
          rezervări pe suport de hârtie în această perioadă.
        </div>
      </div>

      <div class="info-item">
        <div class="info-date">5–11 oct</div>
        <div class="info-text">
          Rezervările la bazele sportive pentru această săptămână rămân valabile.
        </div>
      </div>
    </div>

    <div class="info-footer">
      <a class="info-button" href="https://student.upt.ro" target="_blank" rel="noopener">
        Mergi la student.upt.ro
      </a>
      <span class="info-thanks">Mulțumim pentru înțelegere și cooperare!</span>
    </div>
  </div>
</div>
